export default "__VITE_ASSET__0$XxcGmJ__"